import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export const NicknameEditor = () => {
  const { user, updateName } = useAuth();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await updateName(name.trim());
      toast.success("Nickname aggiornato");
      setEditing(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (!editing)
    return (
      <div className="flex items-center gap-3 mt-2">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight" data-testid="profile-name">{user?.name}</h1>
        <button onClick={() => { setName(user?.name || ""); setEditing(true); }} title="Cambia nickname" data-testid="edit-nickname-button"
          className="h-9 px-3 rounded-full border border-[#26334D] text-slate-400 hover:text-emerald-400 hover:border-emerald-500/60 flex items-center gap-1.5 text-xs transition-colors">
          <Pencil size={14} /> Cambia nickname
        </button>
      </div>
    );

  return (
    <form onSubmit={save} className="flex items-center gap-2 mt-2" data-testid="nickname-form">
      <input autoFocus value={name} onChange={(e) => setName(e.target.value)} maxLength={40} required data-testid="nickname-input"
        className="h-14 w-full max-w-md rounded-lg bg-[#121824] border border-[#26334D] px-4 font-display text-3xl font-black uppercase focus:outline-none focus:border-emerald-500" />
      <button type="submit" disabled={busy || !name.trim()} data-testid="nickname-save-button" className="h-11 w-11 rounded-full bg-emerald-500 text-[#0A0D14] grid place-items-center disabled:opacity-50"><Check size={18} /></button>
      <button type="button" onClick={() => setEditing(false)} data-testid="nickname-cancel-button" className="h-11 w-11 rounded-full border border-[#26334D] text-slate-400 grid place-items-center"><X size={18} /></button>
    </form>
  );
};
